import { cn } from '@/lib/utils';

interface MoneyDisplayProps {
  value: number | null | undefined;
  currency?: 'USD' | 'BRL';
  showCents?: boolean;
  showCurrencyCode?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * Displays a monetary value formatted according to currency
 * USD: $1,500.00 USD
 * BRL: R$1,500.00 BRL
 */
export function MoneyDisplay({
  value,
  currency = 'USD',
  showCents = true,
  showCurrencyCode = true,
  className,
  size = 'md',
}: MoneyDisplayProps) {
  const safeValue = value ?? 0;
  
  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
  }).format(safeValue);
  const formatted = showCurrencyCode ? `${formattedValue} ${currency}` : formattedValue;

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-2xl font-bold',
  };

  return (
    <span className={cn('tabular-nums', sizeClasses[size], className)}>
      {formatted}
    </span>
  );
}

/**
 * Utility function for formatting currency without component
 */
export function formatMoney(
  value: number | null | undefined,
  currency: 'USD' | 'BRL' = 'USD',
  showCents: boolean = true,
  showCurrencyCode: boolean = true
): string {
  const safeValue = value ?? 0;
  
  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
  }).format(safeValue);
  return showCurrencyCode ? `${formattedValue} ${currency}` : formattedValue;
}
